(function () {
  'use strict';

  angular.module('app').service('HotelRoomModalService', HotelRoomModalService);

  HotelRoomModalService.$inject = ['ModalService'];

  function HotelRoomModalService(ModalService) {
    var service = {
      openHotelRoomInfo: openHotelRoomInfo,
    };

    return service;

    ////////////////

    // ---------- openHotelRoomInfo ----------

    function openHotelRoomInfo(parentId, itemId) {
      ModalService.showModal({
        templateUrl: './app/ajs/hotel-rooms/modals/hotel-room-detail-modal.html',
        controller: HotelRoomInfoModalCtrl,
        controllerAs: 'vm',
        inputs: {
          parentId: parentId,
          itemId: itemId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      HotelRoomInfoModalCtrl.$inject = ['parentId', 'itemId', 'HotelRoomService'];
    }

    function HotelRoomInfoModalCtrl(parentId, itemId, HotelRoomService) {
      var vm = this;

      // Initializers
      getItem();

      function getItem() {
        HotelRoomService.getHotelRoom(parentId, itemId).then(function (data) {
          vm.item = data;
        });
      }
    }
  }
})();
